import React from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  TextField,
  MenuItem,
  InputAdornment,
  CircularProgress,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import styles from './styles';

const useStyles = makeStyles(styles);

const Select = ({
  name,
  value,
  disabled,
  onChange,
  onBlur,
  label,
  error,
  helperText,
  data,
  loading,
  fullWidth,
  ...rest
}) => {
  const { t } = useTranslation('common');
  const classes = useStyles();

  return (
    <TextField
      name={name}
      value={value}
      disabled={disabled}
      onChange={onChange}
      onBlur={onBlur}
      label={label}
      error={error}
      helperText={helperText}
      variant="outlined"
      select
      fullWidth={fullWidth}
      InputProps={
        loading
          ? {
              endAdornment: (
                <InputAdornment
                  position="start"
                  classes={{ positionStart: classes.inputAdornment }}
                >
                  <CircularProgress color="secondary" size={20} />
                </InputAdornment>
              ),
            }
          : {}
      }
      {...rest}
    >
      <MenuItem value="" disabled>
        Selecciona...
      </MenuItem>
      {data.map((typeItem) => (
        <MenuItem key={typeItem.value} value={typeItem.value}>
          {typeItem.labelTranslatedKey
            ? t(typeItem.labelTranslatedKey)
            : typeItem.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

Select.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      labelTranslatedKey: PropTypes.string,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  loading: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

Select.defaultProps = {
  disabled: false,
  onBlur: () => {},
  label: null,
  error: false,
  helperText: null,
  loading: false,
  fullWidth: true,
};

export default Select;
